module.exports = __webpack_public_path__ + "img/9791159251795.56ed195f.jpg";